
// React Imports
import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {ListItemIcon, ListItemText} from "@mui/material";
import CalculateIcon from "@mui/icons-material/Calculate";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Badge from "@mui/material/Badge";


export function CdpStatsMenu() {

    const [anchorEl, setAnchorEl] = React.useState(null);

    const isMenuOpen = Boolean(anchorEl);

    const handleMenuOpen = (event) => {


        setAnchorEl(event.currentTarget);
        // console.log("this is the contract selected by the menu click: ", menuContractId);
        // console.log("menuContractName: ", menuContractName);
        // console.log("menuContractLevel: ", menuContractLevel);
        // console.log("menuProductId: ", menuProductId);
        // console.log("menuFailedExpressionCount: ", menuFailedExpressionCount);
        // console.log("menuFailedFilterCount: ", menuFailedFilterCount);
        // console.log("menuInputMissingCount: ", menuInputMissingCount);
        //

    };


    function handleApproveAll()  {
        console.log("Approve Owed Amount For All Records Triggered");
        handleMenuClose();
    };


    function handleRequestAll()  {
        console.log("Request Payment For All Records Triggered");
        handleMenuClose();
    };


    function handleIssueAll()  {
        console.log("Issue Stakeholder Statements For All Records Triggered");
        handleMenuClose();
    };

    //
    // function handleCalcUsage()  {
    //     console.log("Calc Usage Triggered");
    //     handleMenuClose();
    // };



    function handleMenuClose()  {
        setAnchorEl(null);
    };


    const crudId = 'primary-search-account-menu';

    const renderMenu = (

        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={crudId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem
                onClick={handleApproveAll}
            >
                <ListItemIcon>
                    <CalculateIcon color={"action"} fontSize="small" />
                </ListItemIcon>
                <ListItemText>Approve All</ListItemText>
            </MenuItem>
            <MenuItem
                onClick={handleRequestAll}
            >
                <ListItemIcon>
                    <CalculateIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Request All</ListItemText>
            </MenuItem>
            <MenuItem
                onClick={handleIssueAll}
            >
                <ListItemIcon>
                    <CalculateIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Issue All</ListItemText>
            </MenuItem>
            {/*<MenuItem*/}
            {/*    onClick={handleCalcUsage}*/}
            {/*>*/}
            {/*    <ListItemIcon>*/}
            {/*        <CalculateIcon fontSize="small" />*/}
            {/*    </ListItemIcon>*/}
            {/*    <ListItemText>Calc Usage</ListItemText>*/}
            {/*</MenuItem>*/}

        </Menu>
    );


    return (
        <div
        >
            <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-controls={crudId}
                aria-haspopup="true"
                onClick= {handleMenuOpen}
                color="inherit"
            >
                <Badge variant="dot">
                    <MoreVertIcon
                        color="action"
                        fontSize="small"/>
                </Badge>
            </IconButton>

            {renderMenu}
        </div>
    );
}